<section id="toggle-group">
  <mat-button-toggle-group [value]="selectedObjectType" #group1="matButtonToggleGroup" class="left-aligned"
                           (change)="changeEventFormTypeValue(group1.value)" hideSingleSelectionIndicator="true">

    <mat-button-toggle [value]="formFieldType.VALUE" *ngIf="(inputType === formInputType.STRING)"
                       [matTooltip]="'Enter some text'" matTooltipShowDelay="500">
      <span class="material-icons notranslate">text_fields</span>
      TEXT
    </mat-button-toggle>
    <mat-button-toggle [value]="formFieldType.VALUE" *ngIf="(inputType !== formInputType.STRING)"
                       [matTooltip]="'Enter a number'" matTooltipShowDelay="500">
      <span class="material-icons notranslate">numbers</span>
      NUMBER
    </mat-button-toggle>
    <mat-divider [vertical]="true"></mat-divider>
    <mat-button-toggle [value]="formFieldType.FIELD" [matTooltip]="'Enter a field'" matTooltipShowDelay="500">
      <mat-icon>text_fields</mat-icon>
      FIELD
    </mat-button-toggle>
  </mat-button-toggle-group>
  <div [ngSwitch]="selectedObjectType" class="other">
    <app-paired-autocomplete *ngSwitchCase="formFieldType.FIELD"
                             #toggleGroup [selectedFieldControl]="sourceValueControl"
                             [secondaryEntityControl]="sourceSecondaryDescriptor"
                             [primaryEntity]="primaryEntity"
                             [componentId]="'toggle-group'"
                             [entitiesOptions]="entitiesOptions"
                             [dataSourceType]="dataSourceType"
                             [overlayPositioningConfig]="overlayPositioningConfig"
                             [placeholder]="'Choose a field...'"
                             (change)="sourceAutocomplete(sourceValueControl.value)">

    </app-paired-autocomplete>
    <input required *ngIf="((selectedObjectType === formFieldType.VALUE) && (inputType === formInputType.STRING))"
           type="text"
           placeholder="Enter some text" [formControl]="stringInput"
           (change)="valueChange(stringInput.value)">
    <input required *ngIf="((selectedObjectType === formFieldType.VALUE) && (inputType !== formInputType.STRING))"
           type="number"
           placeholder="Enter a number" [formControl]="stringInput"
           (change)="valueChange(stringInput.value)">
  </div>
</section>
